import * as React from 'react';
import { History } from 'history';
import logo from './logo.svg';
// import hambugerIcon from './menu-burger.svg';
// import backIcon from './back-new.svg';
import { storeDispatch } from 'state/Store';
import * as Actions from '../state/actions';
import { UserButton } from './UserButton';
import { useUser } from 'hooks/useUser';
import { canUserSave } from 'utils';

// const Wrapper = styled.button`
//   padding: 8px;
//   minwidth: 36px;
//   border-radius: 999px;
//   margin: 0 -8px;

//   &:hover,
//   &:active {
//     background: rgba(0, 0, 0, 0.1);
//   }
// `;

// const TopBarIconButton: React.FC<{ icon: string; onClick: () => void }> = ({
//   icon,
//   onClick
// }) => {
//   return (
//     <Wrapper onClick={onClick}>
//       <img alt="" src={icon} />
//     </Wrapper>
//   );
// };

export const TopBarMobile: React.FC<{
  history: History;
  flyerId: string | null | undefined;
  onShowMenu: () => void;
  hideButtons: boolean;
}> = ({ history, flyerId, onShowMenu, hideButtons }) => {
  const user = useUser();
  const canSave = canUserSave(user);

  const createNew = React.useCallback(() => {
    history.replace('/');
    storeDispatch(Actions.createNew());
  }, [history]);

  if (hideButtons) {
    return <div className="header-mobile" />;
  }

  return (
    <div className="header-mobile">
      <div className="logo">
        <img alt="" src={logo} draggable={false} />
      </div>
      <div className="header-left">
        {flyerId !== null ? (
          <button className="large secondary with-icon" onClick={createNew}>
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 1L1 6L6 11"
                stroke="#1A1A1A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Back
          </button>
        ) : (
          canSave && (
            <button
              className="library"
              onClick={() => {
                storeDispatch(Actions.showLibrary());
              }}
            />
          )
        )}
      </div>
      <div className="header-right">
        {flyerId !== null ? (
          <button
            className="large primary"
            onClick={() => {
              storeDispatch(Actions.showExportOptions());
            }}
          >
            Export
          </button>
        ) : (
          <UserButton />
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/showcase/TopBarMobile.tsx